import { render } from "./CodeVerificationDialogContent.vue?vue&type=template&id=4871ff90&scoped=true"
import script from "./CodeVerificationDialogContent.vue?vue&type=script&lang=js"
export * from "./CodeVerificationDialogContent.vue?vue&type=script&lang=js"

import "./CodeVerificationDialogContent.vue?vue&type=style&index=0&id=4871ff90&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4871ff90"]])

export default __exports__